import clsx from 'clsx';
import { type FC, type KeyboardEvent, memo } from 'react';
import { getMeetingBadgeLabel, getMeetingDisplayTitle } from '../../helpers/common';
import type { MeetingItemProps } from '../../types';
import MeetingUrl from './MeetingUrl';

const MeetingItem: FC<MeetingItemProps> = ({
  meeting,
  isSelected,
  isDefault,
  onSelect,
  joinUrl,
}) => {
  const badgeLabel = getMeetingBadgeLabel(meeting, isDefault);
  const displayTitle = getMeetingDisplayTitle(meeting);

  const handleSelect = () => onSelect(meeting.room);

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleSelect();
    }
  };

  return (
    // biome-ignore lint/a11y/useSemanticElements: nested copy <button> requires non-<button> container to keep HTML valid
    <div
      role="button"
      tabIndex={0}
      className={clsx('personal-meetings-modal__meeting-item', {
        'personal-meetings-modal__meeting-item--selected': isSelected,
      })}
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
    >
      <div className="personal-meetings-modal__meeting-item-header">
        <span className="personal-meetings-modal__meeting-item-title">{displayTitle}</span>
      </div>
      <MeetingUrl joinUrl={joinUrl} />
      {badgeLabel && <span className="personal-meetings-modal__meeting-badge">{badgeLabel}</span>}
    </div>
  );
};

export default memo(MeetingItem);
